export const isValidDate = (date: string | Date | undefined) => {
  if (!date) return false;
  const dateObj = new Date(date);

  return !isNaN(dateObj.getTime()) && isFinite(dateObj.getTime());
};
